"use strict";
/* Sample formatter Added Please add formatter as and when required globally to avoid duplication */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = function (number, currency) {
    if (currency === void 0) { currency = ''; }
    return "" + currency + number.format("0,0.00");
};
//# sourceMappingURL=dataFormatter.js.map